









































import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import GetAllDistricts from '@/mixins/get-districts'
import { AreaModel } from '@/interfaces/area'
import AppSimpleSelector from './AppSimpleSelector.vue'

@Component({
  components: {
    AppSimpleSelector
  }
})
export default class AppSimpleDistrictSelector extends GetAllDistricts {
  @Prop(Object) readonly value!: AreaModel;
  @Prop(Boolean) readonly showSchool!: boolean;
  @Prop({ type: String, default: '地区：' }) readonly label!: string;
  @Prop({ type: String, default: '120' }) readonly width!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  model: AreaModel | null = null;

  province = -1;
  city = -1;
  region = -1;
  school = -1;

  provinceName = '';
  cityName = '';
  regionName = '';
  schoolName = '';

  districtLoading = false;

  initValueArr: string[] = [];

  mounted () {
    this.model = this.value || null
    this.getProvinces()
  }

  @Watch('value')
  onValueChanged (val: AreaModel, oldVal: AreaModel) {
    if (!val) {
      this.model = val
      this.province = -1
      this.city = -1
      this.region = -1
      this.school = -1
      this.provinceName = ''
      this.cityName = ''
      this.regionName = ''
      this.schoolName = ''
    }
    if (!oldVal) {
      this.initValueArr = (val.mergerName || '').split(',') // 中国，省，市、区
      this.getProvinces()
    }
  }

  @Watch('province')
  onProvinceChanged (val: number) {
    if (val !== -1) {
      const province = this.provinces[val]
      this.getCities(Number(province.id))
      this.model = province
    } else {
      this.model = null
    }
    this.city = -1
    this.region = -1
    this.school = -1
    this.cityName = ''
    this.regionName = ''
    this.schoolName = ''
    this.valueChangedHandler()
  }

  @Watch('city')
  onCityChanged (val: number) {
    if (val === -1) {
      const province = this.provinces[this.province]
      this.model = province
    } else {
      const city = this.cities[val]
      this.getRegions(city.id)
      this.cityName = city.name
      this.model = city
    }
    this.region = -1
    this.valueChangedHandler()
  }

  @Watch('region')
  onDistrictChanged (val: number) {
    if (val === -1) {
      const province = this.provinces[this.province]
      const city = this.cities[this.city]
      this.model = this.city === -1 ? province : city
    } else {
      const region = this.regions[val]
      this.regionName = region.name
      this.model = region
    }
    this.valueChangedHandler()
  }

  @Watch('provinces')
  onProvincesUpdated (val: AreaModel[]) {
    if (this.initValueArr.length <= 1) {
      this.province = -1
      this.city = -1
      this.region = -1
    } else {
      this.province = val.findIndex((province: AreaModel) => {
        return province.name === this.initValueArr[1]
      })
    }
  }

  @Watch('cities')
  onCitiesUpdated (val: AreaModel[]) {
    if (this.initValueArr.length <= 2) {
      this.city = -1
      this.region = -1
    } else {
      this.city = val.findIndex((city: AreaModel) => {
        return city.name === this.initValueArr[2]
      })
    }
  }

  @Watch('regions')
  onRegionsUpdated (val: AreaModel[]) {
    if (this.initValueArr.length <= 3) {
      this.region = -1
    } else {
      this.region = val.findIndex((region: AreaModel) => {
        return region.name === this.initValueArr[3]
      })
    }
  }

  @Emit('input')
  valueChangedHandler () {
    return this.model
  }

  @Emit()
  submit () {
    // do nothing
  }
}
